import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import ArrowLeftIcon from 'assets/image/icons/svg/calendar/arrow-left-light-grey.svg'
import ArrowRightIcon from 'assets/image/icons/svg/calendar/arrow-right-light-grey.svg'
import 'react-datepicker/dist/react-datepicker.css'

import './style.scss'

import DoubleArrowLeftIcon from 'assets/image/icons/svg/calendar/double-arrow-left-grey.svg'
import DoubleArrowRightIcon from 'assets/image/icons/svg/calendar/double-arrow-right-grey.svg'
import DateIcon from 'assets/image/icons/svg/date-icon-yellow.svg'
import { useId } from 'react'
import DatePicker, { type DatePickerProps } from 'react-datepicker'
import { appDay } from 'shared/day'

export function ReactDatePicker({
	label,
	placeholder,
	...props
}: DatePickerProps & {
	label?: string
	placeholder?: string
}) {
	const uniqueId = useId()
	return (
		<div className='datepicker-wrap'>
			{label && (
				<label className='select-label text-field__label' htmlFor={uniqueId}>
					{label}
				</label>
			)}
			<DatePicker
				calendarClassName='datepicker__calendar'
				calendarStartDay={1}
				className='datepicker'
				customInput={
					<TextField
						slotProps={{
							input: {
								endAdornment: (
									<InputAdornment position='end'>
										<img
											alt='dropdownicon'
											className={'datepicker__icon'}
											src={DateIcon}
										/>
									</InputAdornment>
								),
								id: uniqueId,
								style: {
									fontSize: '14px',
									margin: 0,
									padding: '0 6px 0 0'
								}
							}
						}}
						variant='outlined'
					/>
				}
				dateFormat='MM-dd-yyyy'
				{...props}
				placeholderText={placeholder}
				renderCustomHeader={({
					date,
					decreaseMonth,
					decreaseYear,
					increaseMonth,
					increaseYear,
					nextMonthButtonDisabled,
					nextYearButtonDisabled,
					prevMonthButtonDisabled,
					prevYearButtonDisabled
				}) => (
					<div className={'custom-header-content'}>
						<div className='arrow-group'>
							<button
								className={'arrows'}
								disabled={prevYearButtonDisabled}
								onClick={decreaseYear}
								type='button'
							>
								<img
									alt='dropdownicon'
									className={'calendar__year'}
									src={DoubleArrowLeftIcon}
								/>
							</button>
							<button
								className={'arrows'}
								disabled={prevMonthButtonDisabled}
								onClick={decreaseMonth}
								type='button'
							>
								<img
									alt='dropdownicon'
									className={'calendar__month'}
									src={ArrowLeftIcon}
								/>
							</button>
						</div>
						<div className='current-date'>
							{appDay(date).format('MMM YYYY')}
						</div>
						<div className='arrow-group'>
							<button
								className={'arrows'}
								disabled={nextMonthButtonDisabled}
								onClick={increaseMonth}
								type='button'
							>
								<img
									alt='dropdownicon'
									className={'calendar__month'}
									src={ArrowRightIcon}
								/>
							</button>
							<button
								className={'arrows'}
								disabled={nextYearButtonDisabled}
								onClick={increaseYear}
								type='button'
							>
								<img
									alt='dropdownicon'
									className={'calendar__year'}
									src={DoubleArrowRightIcon}
								/>
							</button>
						</div>
					</div>
				)}
				showPopperArrow={false}
				todayButton='Today'
			/>
		</div>
	)
}
